import { render } from "./InputRepeaterKbli.vue?vue&type=template&id=74852000"
import script from "./InputRepeaterKbli.vue?vue&type=script&lang=js"
export * from "./InputRepeaterKbli.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__